import React from 'react';

interface NotificationCountBadgeProps {
  count: number;
  className?: string;
  /** Colour theme. Dashboard uses 'mint' (default); editor uses 'berry'. */
  theme?: 'mint' | 'berry';
}

const NotificationCountBadge: React.FC<NotificationCountBadgeProps> = ({ count, className = '', theme = 'mint' }) => {
  if (count <= 0) return null;
  const label = count > 9 ? '9+' : String(count);
  const colours = theme === 'berry'
    ? 'bg-lureo-brand text-lureo-on-brand'
    : 'bg-lureo-mint text-lureo-emphasis-strong';

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[1.125rem] h-[1.125rem] px-1 rounded-lureo-radius-pill ${colours} text-lureo-10 font-semibold leading-none ${className}`}
    >
      {label}
    </span>
  );
};

export default NotificationCountBadge;
